import { TEAM_FACTION_NAMES, getDisplayTeamBg } from '../displayTheme';

type TeamColor = 'BLUE' | 'RED' | 'GREEN' | 'YELLOW';

interface PollPrepareDisplayProps {
  targetTeam?: TeamColor;
}

function PollPrepareDisplay({ targetTeam }: PollPrepareDisplayProps) {
  const bgClass = getDisplayTeamBg(targetTeam);

  return (
    <div className={`h-screen w-screen flex items-center justify-center ${bgClass}`}>
      <div className="text-center">
        <p className="text-8xl font-bold text-parchment-100 font-display mb-8 animate-pulse">
          Prepararsi al voto!
        </p>
        {targetTeam && (
          <p className="text-5xl text-parchment-200">
            Squadra {TEAM_FACTION_NAMES[targetTeam]}
          </p>
        )}
      </div>
    </div>
  );
}

export default PollPrepareDisplay;
